import {SelectionModel} from '@angular/cdk/collections';
import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSelectChange} from '@angular/material/select';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import * as moment from 'moment';
import {Child} from '../../../models/Child';
import {ExternalClass, ExternalClassDepartment, ExternalSchoolLevel, ExternalSchoolUnit} from '../../../models/externalSchoolInfo';
import {Student} from '../../../models/student';
import {CommonService} from '../../../services/common.service';
import {ExcelService} from '../../../services/excel.service';
import {FileService} from '../../../services/file.service';
import {SchoolService} from '../../../services/school.service';
import {StudentsService} from '../../../services/students.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {SearchDialogComponent} from '../../shared/search-dialog/search-dialog.component';
import {SendSmsDialogComponent} from '../../shared/send-sms-dialog/send-sms-dialog.component';
import {FormAssignmentComponent} from './form-assignment/form-assignment.component';

@Component({
    selector: 'app-students-list',
    templateUrl: './students-list.component.html',
    styleUrls: ['./students-list.component.scss']
})
export class StudentsListComponent implements OnInit {
    //#region Class members

    // tslint:disable-next-line:max-line-length
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
    @ViewChild(MatSort, {static: true}) sort: MatSort;
    @ViewChild('tableContainer', {static: false}) table: ElementRef;

    betweenDateValue = '';
    classId: number;
    classes: any;
    columnsToDisplay = ['select', 'lastName', 'firstName', 'birthday', 'className', 'fatherDisplayName', 'father_email', 'motherDisplayName', 'mother_email'];
    columnsToDisplayExternal = ['select', 'lastName', 'firstName', 'birthday', 'externalSchoolUnitDescription', 'externalSchoolDescription', 'externalClassDescription',
        'externalClassDepartmentDescription', 'fatherDisplayName', 'father_email', 'motherDisplayName', 'mother_email'];
    columnsToDisplaySmall = ['select', 'firstName', 'lastName', 'birthday'];
    currentPage: any;
    currentQuery = '';
    displayStudents: Student[];
    externalClassDepartments: ExternalClassDepartment[] = [];
    externalClasses: ExternalClass[] = [];
    externalSchoolLevels: ExternalSchoolLevel[] = [];
    externalSchoolUnits: ExternalSchoolUnit[] = [];
    filters = '';
    hasExternalChildren: boolean;
    isLoading: boolean;
    originalQuery = '';
    pageTitle: any;
    parents: any;
    public selection: SelectionModel<any>;
    query = '';
    queryOrder: any;
    resultsLength: number;
    searchValue: any;
    selectedClass: any;
    selectedParent: any;
    selectedRecords: number;
    simpleSearchSelectedValue: any;
    skip: number;
    studentSearchFields: any;
    students: MatTableDataSource<any>;
    tableHeight: any;
    windowWidth: any;
    showStudentsMessage: boolean;
    studentsLoading: boolean;
    //#endregion

    //#region Constructor and OnInit
    constructor(private commonService: CommonService,
                public excelService: ExcelService,
                public fileService: FileService,
                public toastMessagesService: ToastMessagesService,
                private schoolService: SchoolService,
                public studentsService: StudentsService,
                public dialog: MatDialog) {
        this.classId = 0;
        this.isLoading = true;
        this.students = new MatTableDataSource<Student>();
        this.classes = [];
        this.displayStudents = [];
        this.parents = [];
        this.tableHeight = window.innerHeight - 400;
        this.selection = new SelectionModel<any>(true, []);
        this.pageTitle = 'Μαθητές';
        this.selectedRecords = 5;
        this.skip = 0;
        this.resultsLength = 20;
        this.windowWidth = window.innerWidth;
        this.hasExternalChildren = localStorage.getItem('externalClasses') ? localStorage.getItem('externalClasses') === 'true' : false;
        this.studentSearchFields = new Child().getSearchFields(this.hasExternalChildren);
        this.showStudentsMessage = false;
        this.studentsLoading = true;
    }

    async ngOnInit() {
        try {
            await this.initCollegeInfo();
            await this.initExternalSchoolInfo();
            if (!this.hasExternalChildren) {
                await this.initClasses();
            } else {
                this.classes = this.externalClasses;
            }

            await this.initializeStudents(null);
        } catch (e) {
            console.log(e);
        }
    }

    //#endregion

    //#region Async Requests
    async initCollegeInfo() {
        try {
            const result = await this.commonService.getList(`college/info`);
            const collegeInfo = result.object[0];
            this.showStudentsMessage = collegeInfo.showStudentsMessage && collegeInfo.showStudentsMessage === 1 ? true : false;
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async initializeStudents(filter) {
        try {
            this.studentsLoading = true;
            this.students = new MatTableDataSource<Student>([]);
            this.students = await this.initStudents(filter);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
            throw e;
        } finally {
            this.studentsLoading = false;
            this.students.paginator = this.paginator;
            this.students.sort = this.sort;
            this.commonService.setPaginatorTexts(this.paginator);
        }
    }

    async initStudents(filter?: any) {
        try {
            return new MatTableDataSource<Student>(await this.commonService.postRequest('students', filter) as Student[]);
        } catch (e) {
            throw e;
        }
    }

    async initExternalSchoolInfo() {
        try {
            this.externalSchoolUnits = await this.schoolService.getExternalUnits();
            this.externalSchoolLevels = await this.schoolService.getExternalLevels();
            this.externalClasses = await this.schoolService.getExternalClasses();
            this.externalClassDepartments = await this.schoolService.getExternalDepartments();
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    getQuery(filters?: any) {
        // this.originalQuery = `children/all?skip=${this.skip}&first=${this.selectedRecords}`;
        this.originalQuery = `children/all`;
        this.query = this.originalQuery;

        if (filters || this.filters) {
            if (filters) {
                this.query += `&filter=${filters}`;
            }
            if (this.filters) {
                this.query += `&filter=${this.filters}`;
            }
        }

        let sort = {};
        if (this.queryOrder && this.queryOrder.direction && this.queryOrder.direction !== '') {
            sort = this.queryOrder;
        } else {
            sort = null;
        }

        const model = {
            skip: this.skip,
            first: this.selectedRecords,
            filter: filters ? filters : this.filters ? this.filters : null,
            sort
        };

        return {endpoint: 'children/all', body: model};
        // return this.query;
    }

    async initClasses() {
        try {
            const classesRequest = await this.commonService.getList(`class`);
            this.classes = classesRequest.object;
        } catch (e) {
            console.log(e.message);
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    //#endregion

    checkClass($event: MatSelectChange) {
        if (this.selectedClass.length === 0) {
            this.applyFilter();
        } else {
            let filters = '';
            for (const studentClass of this.selectedClass) {
                filters += filters ? ` OR classId=${studentClass.id}` : `classId=${studentClass.id}`;
            }

            this.applyFilter(filters);
        }
    }

    private async applyFilter(filter?: any) {
        const query = this.getQuery(filter);
        await this.initializeStudents(query.body);
    }

    initSMS() {
        const students = this.selection.selected as Student[];
        this.dialog.open(SendSmsDialogComponent, {
            disableClose: true,
            hasBackdrop: true,
            panelClass: 'no-overflow',
            data: {
                students
            }
        });
    }

    initFormProc() {
        const students = this.selection.selected as Student[];
        this.dialog.open(FormAssignmentComponent, {
            width: '70%',
            height: '95%',
            panelClass: 'relative-dialog',
            disableClose: true,
            hasBackdrop: true,
            data: {
                students
            }
        });
    }

    //#region checkboxes in table
    public isAllSelected(): boolean {
        const numSelected = this.selection.selected.length;

        // @ts-ignore
        // const numRows = this.students.data.length;
        const numRows = this.students.data.length;

        return numSelected === numRows;
    }

    public masterToggle(): void {
        // @ts-ignore
        this.isAllSelected() ? this.selection.clear() : this.students.data.forEach((row) =>
            this.selection.select(row));
    }

    //#endregion


    clearFields() {
        this.selectedRecords = 5;
        this.skip = 0;
        this.resultsLength = 20;
        this.selectedParent = null;
        this.selectedClass = [];
        this.applyFilter();
    }

    showSearchDialog() {
        this.selection.clear();
        const searchQuery = this.dialog.open(SearchDialogComponent, {
            width: '1200px',
            height: '700px',
            data: {
                searchFields: new Child().getSearchFields(this.hasExternalChildren),
                section: 'students',
                externalSchoolUnits: this.externalSchoolUnits,
                externalSchoolLevels: this.externalSchoolLevels,
                externalClasses: this.externalClasses,
                externalClassDepartments: this.externalClassDepartments,
            }
        });

        searchQuery.afterClosed().subscribe(async (query: string) => {
            if (query) {
                await this.initializeStudents(query);
            } else {
                await this.initializeStudents(null);
            }
        });
    }

    isSticky() {
        return true;
    }

    async fastSearch($event: KeyboardEvent) {
        this.selection.clear();
        if ($event.keyCode === 13) {
            await this.search();
        }
    }

    async search() {
        this.selection.clear();
        if (!this.simpleSearchSelectedValue) {
            this.toastMessagesService.toastMessages('Παρακαλούμε συμπληρώστε κριτήριο αναζήτησης');
            return false;
        }
        let filter = '';

        if (this.simpleSearchSelectedValue.type === 'date') {
            let dateValue;
            let between;
            try {
                dateValue = moment(this.searchValue).format('YYYY-MM-DD');
                between = moment(this.betweenDateValue).format('YYYY-MM-DD');
                filter = `where convert(varchar(10), ${this.simpleSearchSelectedValue.field}, 120) BETWEEN '${dateValue}' AND '${between}'`;
            } catch (e) {
                this.toastMessagesService.toastMessages('Πρέπει και τα 2 πεδία ημερομηνιών να είναι συμπληρωμένα');
                return;
            }
        }
        if (this.simpleSearchSelectedValue.type === 'select') {
            let position = 0;
            let key = '';
            if (this.simpleSearchSelectedValue.field === 'college_school_id') {
                key = 'college_school_unit_id';
            } else if (this.simpleSearchSelectedValue.field === 'college_school_level') {
                key = 'college_school_id';
            } else {
                key = this.simpleSearchSelectedValue.field;
            }
            for (const item of this.simpleSearchSelectedValue.value) {
                filter += position === 0 ? `where ${this.simpleSearchSelectedValue.field} = '${item[key]}'` :
                    ` OR ${this.simpleSearchSelectedValue.field} = '${item[key]}'`;
                position++;
            }

            this.currentQuery = filter;
            this.filters = filter;
        }

        if (this.simpleSearchSelectedValue.type === 'text') {
            filter = `where ${this.simpleSearchSelectedValue.field} LIKE '%${this.searchValue}%'`;
        }

        this.students.data = [];
        this.isLoading = true;
        if (this.searchValue) {
            this.currentQuery = filter;
            this.filters = filter;
            await this.initializeStudents(filter);

        } else {
            this.currentQuery = '';
            this.filters = this.simpleSearchSelectedValue.type === 'text' ? '' : this.filters;
            await this.initializeStudents(this.filters);

        }
    }

    criteriaChanged() {
        this.searchValue = '';
        this.betweenDateValue = '';
        this.simpleSearchSelectedValue.value = '';
    }

    getSelectedValueOptions() {
        let items = [];
        if (this.simpleSearchSelectedValue) {
            switch (this.simpleSearchSelectedValue.field) {
                case 'college_school_id':
                    items = this.externalSchoolUnits;
                    break;
                case 'college_school_level':
                    items = this.externalSchoolLevels;
                    break;
                case 'college_class_id':
                    items = this.classes;
                    break;
                case 'college_department_id':
                    items = this.externalClassDepartments;
                    break;
            }
        }

        return items;
    }

    displayOptionValue(item: any) {
        let display = '';
        switch (this.simpleSearchSelectedValue.field) {
            case 'college_school_id':
                display = item.description;
                break;
            case 'college_school_level':
                display = `${item.description} (${item.school_description})`;
                break;
            case 'college_class_id':
                display = `${item.description} (${item.school_unit_description} - ${item.school_level_description})`;
                break;
            case 'college_department_id':
                display = `${item.displayDescription}`;
                break;

        }
        return display;
    }

    exportToExcel() {

        const {students, columns} = this.formatStudentsModel();
        this.excelService.exportAsCustomExcelFile(students, 'Μαθητές', columns);
    }

    exportToPDF() {
        const {students, columns} = this.formatStudentsModel();
        const data = students;
        this.fileService.onCustomSave('pdf/students', {data, columns}, 'Μαθητές');
    }


    formatStudentsModel() {
        const students = [];
        for (const student of this.students.data) {
            const model = {
                lastName: student.lastName,
                firstName: student.firstName,
                birthday: student.birthday,
                studentClass: student.className,
                externalSchoolUnitDescription: student.externalSchoolUnitDescription,
                externalSchoolDescription: student.externalSchoolDescription,
                externalClassDescription: student.externalClassDescription,
                externalClassDepartmentDescription: student.externalClassDepartmentDescription,
                fatherDisplayName: student.fatherDisplayName,
                father_email: student.father_email,
                motherDisplayName: student.motherDisplayName,
                mother_email: student.mother_email,
            };
            students.push(model);
        }

        const columns = [{
            key: 'lastName',
            label: 'Επώνυμο',
        },
            {
                key: 'firstName',
                label: 'Όνομα',
            },
            {
                key: 'birthday',
                label: 'Ημ. Γέννησης',
            },
            {
                key: 'externalSchoolUnitDescription',
                label: 'Σχολική μονάδα',
            },
            {
                key: 'externalSchoolDescription',
                label: 'Σχολείο',
            },
            {
                key: 'externalClassDescription',
                label: 'Τάξη',
            },
            {
                key: 'externalClassDepartmentDescription',
                label: 'Τμήμα',
            },
            {
                key: 'fatherDisplayName',
                label: 'Πατέρας',
            },
            {
                key: 'father_email',
                label: 'Email Πατέρα',
            },
            {
                key: 'motherDisplayName',
                label: 'Μητέρα',
            },
            {
                key: 'mother_email',
                label: 'Email Μητέρας',
            }];

        return {students, columns};
    }
}

// async initStudentsAsync() {
//     // this.setPaginatorTexts(this.paginator);
//     this.sort.sortChange.subscribe((sort) => {
//         this.isLoading = true;
//         console.log(sort);
//         this.queryOrder = sort;
//         this.paginator.pageIndex = 0;
//     });
//
//     this.paginator.page.subscribe((page) => {
//         this.currentPage = page;
//         this.skip = page.pageIndex === 0 ? 0 : page.pageIndex * page.pageSize;
//         this.selectedRecords = page.pageSize;
//         this.isLoading = true;
//     });
//
//     merge(this.sort.sortChange, this.paginator.page)
//         .pipe(
//             startWith({}),
//             switchMap(() => {
//                 this.students.data = [];
//                 const query = this.getQuery();
//                 return this.commonService.postDataNoPromise(query.endpoint, query.body);
//
//                 // return this.commonService.postDataNoPromise(this.getQuery());
//             }),
//             map((data: any) => {
//
//                 // this.resultsLength = data.count[0].count;
//                 this.resultsLength = data.queryLength;
//                 this.paginator.length = this.resultsLength;
//
//                 this.isLoading = false;
//                 for (const child of data.children) {
//                     this.commonService.validateData(child);
//                 }
//                 return data.children;
//             }),
//             catchError((e) => {
//                 console.log(e);
//                 this.isLoading = true;
//
//                 return observableOf([]);
//             })
//         ).subscribe((data) => {
//         this.students.data = [];
//         for (const child of data) {
//             this.commonService.validateData(child);
//         }
//         this.students.data = data;
//     });
// }
